import axios from "./interceptor";
import { BASE_URL } from "../constant";
import {
    SHOW_SUCCESS,
    SHOW_CARRIER_ITEM_CODE_UPLOAD_DIALOG,
    HIDE_CARRIER_ITEM_CODE_UPLOAD_DIALOG,
    FETCH_CARRIER_ITEM_CODE_SUCCESS,
    FETCH_CARRIER_ITEM_CODE_FAILURE,
    CARRIER_ITEM_CODE_FILTER,
    SORT_CARRIER_ITEM_CODE_LIST,
    CARRIER_ITEM_CODE_CLEAR_FILTER
} from "./types";
import { handleError } from "../utils/utils";

export const batchCarrierItemCode = (carrierItemCode) => async dispatch => {
    console.log("Posting "+ JSON.stringify(carrierItemCode) );
    return axios.post(`${BASE_URL}/current/carrier/carrierItems/upload`, carrierItemCode)
        .then(response => {
            dispatch({
                type: SHOW_SUCCESS,
                payload: {
                    message: 'messages.user.fileUploaded',
                    dialogType: 'info',
                    refresh: true
                }
            });
            return response;
        }).catch(error => {
            handleError(error, dispatch);
            throw error; 
        });
}

export const showCarrierItemCodeUploadDialog = (entity) => {
    return({
        type: SHOW_CARRIER_ITEM_CODE_UPLOAD_DIALOG,
        payload: {
            entity: entity
        }
    })
}

export const hideCarrierItemCodeUploadDialog = () => {
    return ({
        type: HIDE_CARRIER_ITEM_CODE_UPLOAD_DIALOG
    })
}

export const fetchCarrierItemCodeList = (path) => async (dispatch) => {
  try {
    const response = await axios.get(`${BASE_URL}/current/carrier/carrierItems?${path}`)
    dispatch({ type: FETCH_CARRIER_ITEM_CODE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_CARRIER_ITEM_CODE_FAILURE, payload: error });
  }
};

export const updateFiltersForCarrierItemCodeList = (filterKey, filterValue) => {
    return({
        type: CARRIER_ITEM_CODE_FILTER,
        payload: {filterKey, filterValue}
    })
}

export const sortCarrierItemCodeList = (orderBy, sort) => {
    return ({
        type: SORT_CARRIER_ITEM_CODE_LIST,
        payload: {orderBy, sort}
    })
}

export const clearCarrierItemCodeFilters = () => {
    return ({
        type: CARRIER_ITEM_CODE_CLEAR_FILTER
    })
}